import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import AnchorLiveFeedPlayer from '../AnchorLiveFeedPlayer/AnchorLiveFeedPlayer';
import BroadcastChat from '../../BroadcastChat/BroadcastChat';
import GroupShowStore from '../../../store/GroupShowStore';
import './css/AnchorLiveFeed.css';
import './css/AnchorLiveFeed.mobile.css';
import { RootStoreContext } from '../../../context';
import { status } from '../../../constants/sfwStatus';
import LiveBroadcastStore from '../../../store/LiveBroadcastStore';
import TulumRealityShowStore from '../../../store/TulumRealityShowStore';

import AnchorLiveFeedHeader from './AnchorLiveFeedHeader/AnchorLiveFeedHeader';


@observer
class AnchorLiveFeed extends React.PureComponent {
  static contextType = RootStoreContext;
  timeoutId = null;
  state = {
    broadcasterClosedSession: false,
    nsfw: false,
    safeForWatchStatus: status.NO_STATUS,
    roomCount: 0,
    spotlightedByTemptationName: null,
  };

  roomUsersCountListener = (roomCount) => {
    this.setState({ roomCount: roomCount.count });
  };

  onBroadcasterClosedSession = () => {
    LiveBroadcastStore.setBroadcasterClosedSession(true);
  };

  onLiveSessionEnd = () => {
    const { isTulumRealityShow, anchorVideoUrl } = this.props;
    if (!isTulumRealityShow || (isTulumRealityShow && !TulumRealityShowStore.hasActiveStream)) {
      const liveStreamEndedtimeout = setTimeout(() => {
        LiveBroadcastStore.setLastStreamId(anchorVideoUrl?.id);
        LiveBroadcastStore.reset();
      }, 6000);

      this.timeoutId = liveStreamEndedtimeout;
    }
  };

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  onSpotlighterClosedSession = () => {
    LiveBroadcastStore.setSpotlighterClosedSession(true);
  };

  changeNsfwFlag = (nsfw) => {
    if (!nsfw) {
      this.props.fetchStreamDetails();
    }
    this.setState({ nsfw, safeForWatchStatus: nsfw ? status.NSFW : status.SFW });
  };

  broadcastChatCallback = (streamingSourceType) => {
    this.setState({ streamingSourceType });
  };

  getStreamingSourceType = () => {
    const { anchorVideoUrl } = this.props;
    const {
      isInGroupShow,
      streamingSource,
    } = GroupShowStore;
    if (isInGroupShow) {
      return streamingSource;
    }

    return anchorVideoUrl?.streamingSourceType;
  };

  setSpotlightedByTemptationName = (value) => {
    this.setState({ spotlightedByTemptationName: value });
  };

  render() {
    const {
      safeForWatchStatus,
      roomCount,
      nsfw,
      spotlightedByTemptationName,
    } = this.state;
    const {
      tippingStore: { setTippingModal },
      uiStore,
    } = this.context;
    const {
      anchor,
      anchorVideoUrl,
      user,
      chatService,
      chatServiceTempted,
      guestUser,
      anchorId,
      openContextualOverlay,
      isAnchor,
      canSubscribeToAnchor,
      isAlreadySubscribedToAnchor,
      slug,
      history,
      isBanned,
      isSpotlighing,
      spotlighedAnchorUsername,
      spotlighedAnchorNickname,
      isLivePage,
      isWhitelisted,
      toggleStreamLoading,
      shouldHideVolumeRange,
      isTulumRealityShow,
      onTulumStreamError,
      hasStreamError,
      onAllowStreamChangeOnError,
      isEventActive,
      shouldDisplayPlayer = true,
    } = this.props;
    const isGuest = !user.authenticated;
    const {
      isInGroupShow,
      publicChatService,
    } = GroupShowStore;
    const {
      isSpotlight,
      subscribedToOneOfTheAnchors,
      spotlightedByAnchorNickname,
      chatOnline,
      streamStarted,
      broadcasterClosedSession,
      spotlights,
      spotlighterClosedSession,
    } = LiveBroadcastStore;
    const hasStreamViews = anchorVideoUrl?.streamViews?.length > 0;
    const shouldShowLiveFeed = streamStarted &&
      ((anchorVideoUrl && isWhitelisted) || isInGroupShow || isSpotlighing || isEventActive);
    const currentAnchorIsNotSpotlightingAnchor = isSpotlight &&
      !isSpotlighing && (spotlightedByAnchorNickname !== anchor.username);

    if (!shouldShowLiveFeed && !isTulumRealityShow) {
      return null;
    }

    return (
      <div
        className={classnames({
          'anchor-live-feed': true,
          'group-show-feed': isInGroupShow,
          'spotlight-show-feed': isSpotlighing || isSpotlight,
          'broadcast-ended': broadcasterClosedSession,
        })}
        style={{ marginBottom: isTulumRealityShow ? 0 : '', paddingBottom: isTulumRealityShow ? '8px' : '' }}
      >
        <AnchorLiveFeedHeader
          anchor={anchor}
          anchorId={anchorId}
          anchorVideoUrl={anchorVideoUrl}
          broadcasterClosedSession={broadcasterClosedSession}
          canSubscribeToAnchor={canSubscribeToAnchor}
          history={history}
          isAlreadySubscribedToAnchor={isAlreadySubscribedToAnchor}
          isAnchor={isAnchor}
          isBanned={isBanned}
          isGuest={isGuest}
          isInGroupShow={isInGroupShow}
          isSpotlighing={isSpotlighing}
          openContextualOverlay={openContextualOverlay}
          roomCount={roomCount}
          setTippingModal={setTippingModal}
          spotlighedAnchorNickname={spotlighedAnchorNickname}
          spotlighedAnchorUsername={spotlighedAnchorUsername}
          spotlightedByTemptationUsername={spotlightedByTemptationName}
          spotlighterClosedSession={spotlighterClosedSession}
          user={user}
        />
        <div
          className={
            classnames('anchor-live-feed-container', {
              'bottom-padding': currentAnchorIsNotSpotlightingAnchor,
              'tulum-show-chat': isTulumRealityShow && chatOnline,
              'chat-disabled': (nsfw && canSubscribeToAnchor && !chatOnline) || (!canSubscribeToAnchor && !chatOnline),
              'chat-disabled-tulum': isTulumRealityShow && !chatOnline,
            })
          }
          style={{ marginBottom: isTulumRealityShow ? 0 : '' }}
        >
          <div className={classnames("anchor-live-feed-player-wrapper", {
            'hide-chat-mobile': isTulumRealityShow && (!user?.authenticated || canSubscribeToAnchor)
          })}>
            <AnchorLiveFeedPlayer
              anchorId={anchorId}
              anchorName={anchor.name}
              anchorUsername={anchor.username}
              anchorVideoUrl={anchorVideoUrl}
              broadcasterClosedSession={broadcasterClosedSession}
              canSubscribeToAnchor={canSubscribeToAnchor}
              hasStreamError={hasStreamError}
              hasStreamViews={hasStreamViews}
              isAlreadySubscribedToAnchor={isAlreadySubscribedToAnchor}
              isAnchor={isAnchor}
              isBanned={isBanned}
              isLivePage={isLivePage}
              isSpotlighing={isSpotlighing}
              isSpotlight={isSpotlight}
              isTulumRealityShow={isTulumRealityShow}
              nsfw={nsfw}
              safeForWatchStatus={safeForWatchStatus}
              setTippingModal={setTippingModal}
              shouldDisplayPlayer={shouldDisplayPlayer}
              shouldHideVolumeRange={shouldHideVolumeRange}
              slug={slug}
              spotlighedAnchorNickname={spotlighedAnchorNickname}
              spotlighedAnchorUsername={spotlighedAnchorUsername}
              spotlighterClosedSession={spotlighterClosedSession}
              subscribedToOneOfTheAnchors={subscribedToOneOfTheAnchors}
              title={anchor.name}
              toggleStreamLoading={toggleStreamLoading}
              uiStore={uiStore}
              user={user}
              onAllowStreamChangeOnError={onAllowStreamChangeOnError}
              onLiveSessionEnd={this.onLiveSessionEnd}
              onNetworkError={this.props.onNetworkError}
              onTulumStreamError={onTulumStreamError}
            />
          </div>
          <BroadcastChat
            anchor={anchor}
            anchorId={anchorId}
            broadcasting={true}
            canSubscribeToAnchor={canSubscribeToAnchor}
            changeNsfwFlag={this.changeNsfwFlag}
            chatService={chatService}
            chatServiceTempted={isInGroupShow ? publicChatService : chatServiceTempted}
            guestUser={guestUser}
            isBanned={isBanned}
            isInGroupShow={isInGroupShow}
            isSpotlighing={isSpotlighing}
            isSpotlight={isSpotlight}
            isTulumRealityShow={isTulumRealityShow}
            nsfw={nsfw}
            openContextualOverlay={openContextualOverlay}
            roomCount={roomCount}
            roomUsersCountListener={this.roomUsersCountListener}
            setSpotlightedByTemptationName={this.setSpotlightedByTemptationName}
            shouldDisplayPlayer={shouldDisplayPlayer}
            spotlighedAnchorNickname={spotlighedAnchorNickname}
            spotlighedAnchorUsername={spotlighedAnchorUsername}
            spotlightedByAnchorNickname={spotlightedByAnchorNickname}
            spotlights={spotlights}
            streamingSourceType={this.getStreamingSourceType()}
            user={user}
            onBroadcasterClosedSession={this.onBroadcasterClosedSession}
            onSpotlighterClosedSession={this.onSpotlighterClosedSession}
          />
        </div>
      </div>
    );
  }
}

export default AnchorLiveFeed;
